import { OpenInNewIcon } from '@/components/icon'

interface Props {
  text: string
  outerLink?: string
  outerLinkText?: string
}
export const LabelTextValue: React.FC<Props> = ({
  text,
  outerLink = '',
  outerLinkText = '',
}) => {
  return (
    <div>
      {text}
      {outerLink && (
        <a
          href={outerLink}
          className="inline-block relative pt-[7px] pr-[10px] pb-0 pl-[10px] ml-[10px] h-7 text-xs font-normal leading-3 text-center text-[#293c6f] hover:text-[#293c6f] no-underline hover:no-underline align-middle whitespace-nowrap bg-[#f3f6fa] hover:bg-[#e7edf5] rounded-[52px] border border-[#d9e2ed] border-solid cursor-pointer hover:outline-none"
        >
          <p className="flex">
            <span className="mr-[5px]">{outerLinkText}</span>
            <OpenInNewIcon />
          </p>
        </a>
      )}
    </div>
  )
}
